module.exports = __webpack_public_path__ + "assets/8f158d8ccd8cc70b37d4a5dc91c58f8b.mp3";